// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__kaL-R","empty":"ModalGraph_empty__18aYd"};